import type { Collection } from '@/types/content';

export const collections: Collection[] = [
  {
    id: 1,
    title: '赵慧兰的三次沉默',
    desc: '从饭桌到窗边，盘点这位母亲没有台词却最有戏的几个瞬间。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20style%20image%20of%20an%20elegant%20mature%20Chinese%20woman%20gazing%20out%20a%20window%20at%20night%2C%20warm%20lamp%20glow%2C%20city%20bokeh%20outside%2C%20cinematic%20shallow%20depth%20of%20field%2C%20melancholic%20refined%20mood%2C%20harmonious%20warm%20neutral%20tones&width=520&height=360&seq=drama-collection01-cover-2024&orientation=landscape',
    href: '/actor/2',
  },
  {
    id: 2,
    title: '雨夜名场面合集',
    desc: '重看全剧最催泪的那场雨——守候、开门，与一句迟到的道歉。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20style%20image%20of%20a%20young%20man%20standing%20in%20heavy%20rain%20under%20a%20street%20lamp%20outside%20an%20apartment%20building%20at%20night%2C%20cool%20blue%20tones%20with%20warm%20window%20lights%2C%20cinematic%20shallow%20depth%20of%20field%2C%20lonely%20mood&width=520&height=360&seq=drama-collection02-cover-2024&orientation=landscape',
    href: '/episode/8',
  },
  {
    id: 3,
    title: '一桌饭里的两代人',
    desc: '把剧中所有饭桌戏串起来看，你会发现关系是如何一点点融化的。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20style%20image%20of%20a%20warm%20Chinese%20family%20dinner%20table%20from%20above%20with%20steaming%20dishes%20and%20chopsticks%2C%20golden%20evening%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20intimate%20hopeful%20mood%2C%20harmonious%20warm%20tones&width=520&height=360&seq=drama-collection03-cover-2024&orientation=landscape',
    href: '/episodes',
  },
  {
    id: 4,
    title: '新观众追剧指南',
    desc: '第一次看《女友的妈妈》？从这五集开始，快速进入剧情核心。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20style%20image%20of%20a%20cozy%20living%20room%20with%20a%20large%20screen%20glowing%20warmly%2C%20sofa%20and%20blanket%2C%20soft%20evening%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20inviting%20relaxed%20mood%2C%20harmonious%20warm%20neutral%20tones&width=520&height=360&seq=drama-collection04-cover-2024&orientation=landscape',
    href: '/news',
  },
];